import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SmartContainer from "@/pages/SmartContainer";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SmartContainer />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
